import SEOHead from '../../components/base/SEOHead';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceDetails from './components/ServiceDetails';
import WhyChooseStrip from './components/WhyChooseStrip';
import ServiceCTA from './components/ServiceCTA';

export default function ServicesPage() {
  const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Home Care Services",
      "name": "KaliKare Homecare Services",
      "description": "Comprehensive home care services including personal care, companion care, dementia care, respite care, 24/7 live-in care, and post-hospitalization care in Radnor, PA.",
      "url": `${baseUrl}/services`,
      "provider": {
        "@type": "LocalBusiness",
        "name": "KaliKare Homecare",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "201 King of Prussia Rd, Suite 650",
          "addressLocality": "Radnor",
          "addressRegion": "PA",
          "postalCode": "19087",
          "addressCountry": "US"
        },
        "telephone": "+1-833-438-5542",
        "email": "info@kalikarehomecare.com",
        "url": baseUrl
      },
      "areaServed": {
        "@type": "State",
        "name": "Pennsylvania"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Home Care Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Personal Care",
              "description": "Assistance with daily activities including bathing, dressing, grooming, and mobility support to help clients maintain independence and dignity."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Companion Care",
              "description": "Friendly companionship, conversation, light housekeeping, meal preparation, and assistance with errands to combat loneliness and enhance quality of life."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Dementia & Alzheimer\u2019s Care",
              "description": "Specialized care for individuals with memory impairments, providing a safe environment, cognitive stimulation, and compassionate support."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Respite Care",
              "description": "Temporary relief for family caregivers, offering professional care for your loved one while you take a break to rest and recharge."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "24/7 Live-In Care",
              "description": "Round-the-clock care in the comfort of home, ensuring safety, assistance, and companionship at all times."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Post-Hospitalization Care",
              "description": "Transitional care after hospital discharge, helping clients recover safely at home with medication management, wound care, and mobility assistance."
            }
          }
        ]
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Services",
          "item": `${baseUrl}/services`
        }
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What personal care services does KaliKare Homecare provide?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KaliKare Homecare provides personal care services including assistance with bathing, dressing, grooming, and mobility support to help clients maintain independence and dignity at home."
          }
        },
        {
          "@type": "Question",
          "name": "Does KaliKare offer specialized dementia and Alzheimer\u2019s care?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, KaliKare offers specialized dementia and Alzheimer\u2019s care, providing a safe environment, cognitive stimulation, and compassionate support for individuals with memory impairments."
          }
        },
        {
          "@type": "Question",
          "name": "What is respite care and does KaliKare provide it?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Respite care provides temporary relief for family caregivers. KaliKare offers professional respite care so family members can rest and recharge while their loved one receives quality care."
          }
        },
        {
          "@type": "Question",
          "name": "Does KaliKare Homecare offer post-hospitalization care?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, KaliKare provides post-hospitalization transitional care to help clients recover safely at home, including medication management, wound care, and mobility assistance after hospital discharge."
          }
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Home Care Services in Radnor PA – KaliKare | Personal, Companion & Dementia Care"
        description="KaliKare offers comprehensive home care services in Radnor, PA including personal care, companion care, dementia and Alzheimer\u2019s care, respite care, 24/7 live-in care, and post-hospitalization care. Compassionate, personalized support tailored to your loved one\u2019s needs."
        canonical="/services"
        jsonLd={jsonLd}
      />
      <Navbar />
      <ServiceHero />
      <ServiceDetails />
      <WhyChooseStrip />
      <ServiceCTA />
      <Footer />
    </div>
  );
}
